import React from "react";
import { Check } from "lucide-react";
import { toInt } from "../../pages/UserTest/testUtils";

/**
 * SingleChoiceQuestion
 * Big selectable cards instead of radios. One selection allowed; selecting
 * calls onSelect(optionId), which the page uses to save + auto-advance.
 */
const SingleChoiceQuestion = ({ question, selectedOptionId, onSelect }) => {
  return (
    <div
      className="choice-question"
      role="radiogroup"
      aria-label={question.questionText}
    >
      {(question.answerOptions || []).map((option) => {
        const optId = toInt(option.answerOptionId);
        const isSelected = optId != null && toInt(selectedOptionId) === optId;

        return (
          <button
            key={option.answerOptionId}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`choice-card mode-single ${isSelected ? "selected" : ""}`}
            onClick={() => optId != null && onSelect(optId)}
          >
            <span className="choice-indicator">
              <Check />
            </span>
            <span className="choice-label">{option.answerText}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SingleChoiceQuestion;
